var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-frame",class:[_vm.container ? 'page-container' : 'page-wrap']},[_c('main',{staticClass:"wrap"},[(!_vm.loading)?_vm._t("default"):[_c('el-skeleton',{staticStyle:{"margin":"24px"}}),_c('el-skeleton',{staticStyle:{"margin":"24px"}})]],2),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }